import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'sort',
  standalone: true,
})
export class SortPipe implements PipeTransform {
  search;

  transform<T>(value: T[], sort?: string, reverse?: boolean): T[] {
    if (!sort || !value) {
      return value;
    }
    value.sort(this.sort(sort));
    return reverse ? value.reverse() : value;
  }

  sort(field): (a, b) => number {
    return (a, b) => {
      let avalue = this.resolve(field, a);
      let bvalue = this.resolve(field, b);
      // We need == here because we need to match undefined and null
      // tslint:disable-next-line:triple-equals
      if (avalue == undefined) {
        avalue = '';
      }
      // tslint:disable-next-line:triple-equals
      if (bvalue == undefined) {
        bvalue = '';
      }
      if ((typeof avalue === 'string' || avalue instanceof String) && (typeof bvalue === 'string' || bvalue instanceof String)) {
        avalue = avalue.toLowerCase();
        bvalue = bvalue.toLowerCase();
      }
      if (avalue === bvalue) {
        return 0;
      }
      return avalue > bvalue && 1 || -1;
    };
  }

  resolve(path, obj, separator = '.'): any {
    const properties = Array.isArray(path) ? path : path.split(separator);
    return properties.reduce((prev, curr) => prev && prev[curr], obj);
  }
}
